export default __webpack_public_path__ + "static/media/checkin-icon.22f6ba15.svg";